import { countOccurrencesInArray } from "../../../../../common/helpers/helpers";

export const variantFields = [
  {
    key: "clinical-significance",
    title: "Clinical Significance",
    width: "12%",
  },
  {
    key: "amp-category",
    title: "Somatic Variant Classification Category",
    width: "12%",
  },
  { key: "assertion-type", title: "Assertion", width: "12%" },
  { key: "disease", title: "Disease", width: "14%" },
  { key: "info", title: "General Information", width: "12%" },
  { key: "drugs", title: "Drugs", width: "38%" },
];

export const molecularProfileFields = [
  {
    key: "molecular-profile",
    title: "Molecular Profile",
    width: "35%",
  },
  { key: "evidence-item-ids", title: "Evidence(s)", width: "40%" },
  { key: "variant", title: "Variant(s)", width: "25%" },
];

export const getFormattedData = (item) => {
  const collectDiseaseData = [];
  item.items.forEach((entry) => {
    if (entry?.disease) collectDiseaseData.push(entry.disease);
  });
  const dataArray = countOccurrencesInArray(collectDiseaseData);
  return Object.keys(dataArray)
    .map((key) => ({ key, value: dataArray[key] }))
    .sort((a, b) => b?.value - a?.value);
};
